import { firebaseDb, firebaseStorage } from './init'
import {
  Timestamp,
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  DocumentData
} from 'firebase/firestore'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
//@ts-ignore
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'

export async function fetchDocuments(collectionPath: string): Promise<DocumentData[]> {
  try {
    const docRef = collection(firebaseDb, collectionPath)
    const docSnap = await getDocs(docRef)
    return docSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() })) as DocumentData[]
  } catch (error) {
    return []
  }
}

export async function fetchDocument(collectionPath: string, documentId: string): Promise<DocumentData | null> {
  const docRef = doc(firebaseDb, collectionPath, documentId)
  const docSnap = await getDoc(docRef)
  return docSnap.exists() ? ({ id: docSnap.id, ...docSnap.data() }) as DocumentData : null
}

export async function removeDocument(collectionPath: string, documentId: string): Promise<boolean> {
  try {
    const docRef = doc(firebaseDb, collectionPath, documentId)
    await deleteDoc(docRef)
    return true
  } catch (error) {
    console.error(error)
    return false
  }
}

export const uploadImageToFirebase = async (folderPath: String, imageFile: File, isBuffer?: Boolean) => {
  try {
    const filePath = `${folderPath}/${uuidv4()}`
    const storageRef = ref(firebaseStorage, filePath)
    const metadata = {
      contentType: 'image/jpeg',
    }

    await uploadBytes(storageRef, imageFile, isBuffer && metadata)

    const downloadURL = await getDownloadURL(storageRef)

    return downloadURL
  } catch (error) {
    console.error('Error uploading image to Firebase:', error)
    return null
  }
}

export const downloadImage = async (imageUrl: string) => {
  try {
    const response = await axios.get(imageUrl, { responseType: 'arraybuffer' });
    return response.data
  } catch (error) {
    throw new Error('Failed to download image')
  }
}
